@if (document && quote) {
  <div>
    <mat-expansion-panel
      class="curtains"
      [expanded]="isSentToInsurerTray && !canBeReplacedOrMerged && !previousQuote"
      (closed)="quoteCurtainOpened = false"
      (opened)="quoteCurtainOpened = true"
      #panel>
      <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
        <mat-panel-title class="quote-title">
          <div>
            @if (document.date) {
              <div class="received-date">
                {{ document.date | dateepoch: timezone }} {{ document.date | time: timezone }}

                @if (quote.original && quotingSystemName) {
                  <span>from {{ quotingSystemName }}</span>
                }
              </div>
            }

            <div class="quote-number">
              <h5>
                <span class="subtitle-1">
                  {{ canBeReplacedOrMerged ? 'New quote' : quote.original ? 'Original' : 'Supplement' }}
                </span>

                @if (quote.supplementNumber > 0) {
                  <span class="subtitle-1">{{ quote.supplementNumber }}</span>
                }

                {{ quote.quoteNumber }}
              </h5>

              @if (!quote.assessed && document.submitted) {
                <div class="pending-box" appHighlightStatus="PENDING">PENDING</div>
              }

              @if (quote.assessed) {
                <div
                  (click)="$event.stopPropagation(); tooltipAssessedDate.toggle()"
                  class="assessed-box"
                  appHighlightStatus="ASSESSED">
                  ASSESSED
                  <div
                    #tooltipAssessedDate="matTooltip"
                    matTooltip="{{ quote.assessedDateTime | dateepoch: timezone }} {{
                      quote.assessedDateTime | time: timezone
                    }}"
                    matTooltipClass="timestamp-tooltip"></div>
                </div>
              }
            </div>
          </div>
          <div>
            <div class="body-2">Quoted Parts</div>
            <div class="subtitle-2">$ {{ quote.estPartsTotal | number: '1.2-2' }}</div>
          </div>
          <div>
            <div class="body-2">Quoted Labour</div>
            <div class="subtitle-2">$ {{ quote.estLabourTotal | number: '1.2-2' }}</div>
          </div>
          <div>
            <div class="body-2">Quoted Sublet</div>
            <div class="subtitle-2">$ {{ quote.estSubletTotal | number: '1.2-2' }}</div>
          </div>
          <div>
            <div class="body-2">Total Quoted</div>
            <div class="subtitle-2">$ {{ quote.estTotal | number: '1.2-2' }}</div>
          </div>
        </mat-panel-title>
        <mat-panel-description class="kebab-panel">
          @if (!document?.submitted) {
            <div class="secondary-icon">
              <button matIconButton (click)="$event.stopPropagation(); confirmDeleteQuote()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      <form [formGroup]="quoteForm">
        <div class="quote-fields-box">
          <div class="quote-fields-grid">
            <mat-form-field class="large">
              <mat-label>Estimator</mat-label>
              <input formControlName="estimator" matInput />
            </mat-form-field>

            <mat-form-field [class.read-only]="quoteDate.disabled" class="small primary-icon">
              <mat-label>Quote Date</mat-label>
              <input
                (keypress)="dateInputHelper.restrictDateInput($event)"
                [matDatepicker]="quoteDatepicker"
                formControlName="quoteDate"
                matInput />
              <mat-datepicker-toggle [for]="quoteDatepicker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #quoteDatepicker></mat-datepicker>
              @if (quoteDate.enabled) {
                <mat-hint>Date format DD/MM/YYYY</mat-hint>
              }
              @if (!quoteDate.valid) {
                <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
              }
            </mat-form-field>
          </div>

          @if (quote?.repairerInstructions) {
            <div class="repairer-instructions">
              <div class="field-label body-2">Repairer Instructions</div>
              <p class="subtitle-2">{{ quote.repairerInstructions }}</p>
            </div>
          }
        </div>

        <div>
          <h4>Estimated Repair Commencement</h4>
          <div>
            <mat-form-field [class.read-only]="estimatedStartDate.disabled" class="small primary-icon">
              <mat-label>Estimated Start Date</mat-label>
              <input
                (keypress)="dateInputHelper.restrictDateInput($event)"
                [matDatepicker]="startDatepicker"
                formControlName="estimatedStartDate"
                matInput />
              <mat-datepicker-toggle [for]="startDatepicker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #startDatepicker></mat-datepicker>
              @if (estimatedStartDate.enabled) {
                <mat-hint>Date format DD/MM/YYYY</mat-hint>
              }
              @if (!estimatedStartDate.valid) {
                <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
              }
            </mat-form-field>

            <mat-form-field [class.read-only]="estimatedDuration.disabled" class="small ml-20 [&_.mat-mdc-text-field-wrapper]:!pr-16">
              <mat-label>Estimated Days to Repair</mat-label>
              <input formControlName="estimatedDuration" matInput type="number" />
              @if (displayDays) {
                <span matSuffix>Days</span>
              }
              @if (estimatedDuration.errors) {
                <mat-error> Only numbers are accepted </mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field [class.read-only]="estimatedRepairCommencementNotes.disabled" class="block w-full mt-20">
            <mat-label>Comments</mat-label>
            <textarea
              formControlName="estimatedRepairCommencementNotes"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
            ></textarea>
          </mat-form-field>
        </div>

        <div class="overview-filter">
          <h4 [class.red]="overviewCheckbox.checked">Overview</h4>
          <mat-checkbox #overviewCheckbox [class.hidden]="!quote.assessed" class="checkbox-margin">
            Show only assessor adjustments and notes
          </mat-checkbox>
        </div>

        <div class="overview-grid">
          <div>
            <div class="body-2">Labour</div>
            <div class="overview-amounts body-1">
              $
              <div class="section-amount">
                {{ (quote.assessed ? quote.assessedLabourTotal : quote.estLabourTotal) | number: '1.2-2' }}
              </div>
              @if (quote.assessed) {
                <ng-container
                  [ngTemplateOutletContext]="{
                    estimatedAmount: quote.estLabourTotal,
                    assessedAmount: quote.assessedLabourTotal
                  }"
                  [ngTemplateOutlet]="assessedTotals" />
              }
            </div>
          </div>
          <div>
            <div class="body-2">Parts</div>
            <div class="overview-amounts body-1">
              $
              <div class="section-amount">
                {{ (quote.assessed ? quote.assessedPartsTotal : quote.estPartsTotal) | number: '1.2-2' }}
              </div>
              @if (quote.assessed) {
                <ng-container
                  [ngTemplateOutletContext]="{
                    estimatedAmount: quote.estPartsTotal,
                    assessedAmount: quote.assessedPartsTotal
                  }"
                  [ngTemplateOutlet]="assessedTotals" />
              }
            </div>
          </div>
          <div>
            <div class="body-2">Sublet</div>
            <div class="overview-amounts body-1">
              $
              <div class="section-amount">
                {{ (quote.assessed ? quote.assessedSubletTotal : quote.estSubletTotal) | number: '1.2-2' }}
              </div>

              @if (quote.assessed) {
                <ng-container
                  [ngTemplateOutletContext]="{
                    estimatedAmount: quote.estSubletTotal,
                    assessedAmount: quote.assessedSubletTotal
                  }"
                  [ngTemplateOutlet]="assessedTotals" />
              }
            </div>
          </div>
          <div>
            <div class="body-2">Subtotal</div>
            <div class="overview-amounts body-1">
              $
              <div class="subtotal-amount">
                {{ (quote.assessed ? quote.assessedSubTotal : quote.estSubTotal) | number: '1.2-2' }}
              </div>
            </div>
          </div>
          <div>
            <div class="body-2">GST</div>
            <div class="overview-amounts body-1">
              $
              <span class="subtotal-amount">
                {{ (quote.assessed ? quote.assessedGSTTotal : quote.estGSTTotal) | number: '1.2-2' }}
              </span>
            </div>
          </div>
          <div>
            <div class="body-2">Total</div>
            <div class="overview-amounts body-1">
              $
              <span class="total-amount">
                {{ (quote.assessed ? quote.assessedTotal : quote.estTotal) | number: '1.2-2' }}
              </span>
              @if (quote.assessed) {
                <ng-container
                  [ngTemplateOutletContext]="{ estimatedAmount: quote.estTotal, assessedAmount: quote.assessedTotal }"
                  [ngTemplateOutlet]="assessedTotals" />
              }
            </div>
          </div>
        </div>
        <!-- LABOUR SECTION -->
        @if (quote.labourSections) {
          <h4 class="labour-title">Labour</h4>
        }

        @for (labourSection of labourSections.controls; track i; let i = $index) {
          <div formArrayName="labourSections" class="labour-sections">
            <div [formGroupName]="i">
              <div class="section-header">
                <div class="group">
                  <div class="title-1">{{ labourSection.value.labourType }}</div>
                  <div class="paint-group subtitle-2">{{ labourSection.value.groupName }}</div>
                </div>
                <div class="rates">
                  <div class="body-2">Est. rate</div>
                  <div class="paint-group subtitle-2">
                    @if (!quote.manual || quote.submitted) {
                      <div>$ {{ labourSection.value.estimateRate }}</div>
                    }
                    @if (quote.manual && !quote.submitted) {
                      <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                        <input
                          formControlName="estimateRate"
                          matInput
                          (focusout)="setEstimatedRate(i, estimateRate.value)"
                          #estimateRate />
                        <div class="prefix body-1" matPrefix>$</div>
                        @if (labourSection.get('estimateRate').errors?.pattern) {
                          <mat-error>Invalid format</mat-error>
                        }
                      </mat-form-field>
                    }
                  </div>

                  @if (labourSection.value.assessedRate) {
                    <div class="body-2">Ass. rate</div>
                    <div class="paint-group subtitle-2">
                      <div
                        [ngClass]="{ emphasis: labourSection.value.assessedRate !== labourSection.value.estimateRate }"
                        class="assess-indicator">
                        $ {{ labourSection.value.assessedRate | number: '1.2-2' }}
                        <div
                          [ngClass]="{
                            ASSESSED_UNDER: +labourSection.value.assessedRate !== +labourSection.value.estimateRate
                          }"
                          class="indicator margin-left">
                          @if (+labourSection.value.assessedRate < +labourSection.value.estimateRate) {
                            <mat-icon>keyboard_arrow_down</mat-icon>
                          } @else if (+labourSection.value.assessedRate > +labourSection.value.estimateRate) {
                            <mat-icon>keyboard_arrow_up</mat-icon>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <table
                formArrayName="items"
                [dataSource]="labourSection.value.items | filter: 'OVERVIEW' : overviewCheckbox.checked"
                class="table-style"
                mat-table
                [trackBy]="trackByFn">
                <ng-container matColumnDef="description">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Description</th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    <div class="description-cell">
                      <ng-container
                        [ngTemplateOutletContext]="{ item: item, added: item.addedInV6 }"
                        [ngTemplateOutlet]="assessedStatusIndicator" />

                      @if (!quote.manual || quote.submitted) {
                        <div>{{ item.description }}</div>
                      }
                      @if (quote.manual && !quote.submitted) {
                        <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                          <input
                            formControlName="description"
                            type="text"
                            id="{{ 'description-' + i + index }}"
                            (focusout)="addOrEditLineLaboursItem(i, index)"
                            matInput
                            #labourDescriptionsRef />
                          @if (labourItem(i).controls[index].get('description').errors?.required) {
                            <mat-error>Description is <strong>required</strong></mat-error>
                          }
                        </mat-form-field>
                      }
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="note">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessor Note</th>
                  <td *matCellDef="let item; let index = index" class="emphasis" mat-cell [formGroupName]="index">
                    @if (item.assessorNote) {
                      <div class="note-container">
                        <mat-icon class="note-icon">add_comment</mat-icon>
                        <div>{{ item.assessorNote }}</div>
                      </div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="total">
                  <td *matFooterCellDef mat-footer-cell class="text-end" colspan="2">
                    <div>Total</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="estimateHours">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Est. Hours</th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    @if (!quote.manual || quote.submitted) {
                      <div>{{ item.estimateHours }}</div>
                    }
                    @if (quote.manual && !quote.submitted) {
                      <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                        <input
                          formControlName="estimateHours"
                          id="{{ 'estimateHours-' + i + index }}"
                          (focusout)="
                            updateEstimateHours(i, index, estimateHoursValue.value); addOrEditLineLaboursItem(i, index)
                          "
                          matInput
                          #estimateHoursValue />
                        @if (labourItem(i).controls[index].get('estimateHours').errors?.pattern) {
                          <mat-error>Invalid format</mat-error>
                        }
                      </mat-form-field>
                    }
                  </td>
                  <td *matFooterCellDef mat-footer-cell>
                    <div>
                      {{ labourSection.value.totalEstimateHours | number: '1.2-2' }}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="assessedHours">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Ass. Hours</th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    @if (item.assessedHours || item.assessedHours === 0) {
                      <div
                        [ngClass]="{
                          emphasis: item.assessedStatus !== 'ASSESSED_EQUAL',
                          red: item.assessedStatus === 'ASSESSED_REJECTED'
                        }"
                        class="assess-indicator">
                        {{ item.assessedHours | number: '1.2-2' }}
                        <ng-container
                          [ngTemplateOutletContext]="{ item: item, small: true, added: item.addedInV6 }"
                          [ngTemplateOutlet]="assessedStatusIndicator" />
                      </div>
                    }
                  </td>
                  <td *matFooterCellDef mat-footer-cell>
                    @if (quote.assessed) {
                      <div>{{ labourSection.value.totalAssessedHours | number: '1.2-2' }}</div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="estimateAmount">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Est. Amount</th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    @if (!quote.manual || quote.submitted) {
                      <div class="amount-cell">
                        <div class="sign-cell">$</div>
                        <div>{{ item.estimateAmount }}</div>
                      </div>
                    }
                    @if (quote.manual && !quote.submitted) {
                      <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                        <input
                          formControlName="estimateAmount"
                          id="{{ 'estimateAmount-' + i + index }}"
                          (keydown.tab)="
                            updateEstimateAmount(i, index, estimateAmountValue.value);
                            addOrEditLineLaboursItem(i, index)
                          "
                          (focusout)="
                            updateEstimateAmount(i, index, estimateAmountValue.value);
                            addOrEditLineLaboursItem(i, index)
                          "
                          matInput
                          #estimateAmountValue />
                        @if (item.estimateAmount) {
                          <div class="prefix body-1" matPrefix>$</div>
                        }
                        @if (labourItem(i).controls[index].get('estimateAmount').errors?.pattern) {
                          <mat-error>Invalid format</mat-error>
                        }
                        @if (labourItem(i).controls[index].get('estimateAmount').errors?.required) {
                          <mat-error>Amount is <strong>required</strong></mat-error>
                        }
                      </mat-form-field>
                    }
                  </td>
                  <td *matFooterCellDef mat-footer-cell>
                    <div class="amount-cell">
                      <div class="sign-cell-total">$</div>
                      {{ labourSection.value.totalEstimateAmount | number: '1.2-2' }}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="assessedAmount">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Ass. Amount</th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    @if (item.assessedAmount || item.assessedAmount === 0) {
                      <div class="amount-cell">
                        <div class="sign-cell">$</div>
                        <div
                          [ngClass]="{
                            emphasis: item.assessedStatus !== 'ASSESSED_EQUAL',
                            red: item.assessedStatus === 'ASSESSED_REJECTED'
                          }"
                          class="assess-indicator">
                          {{ item.assessedAmount | number: '1.2-2' }}
                          <ng-container
                            [ngTemplateOutletContext]="{ item: item, small: true, added: item.addedInV6 }"
                            [ngTemplateOutlet]="assessedStatusIndicator" />
                        </div>
                      </div>
                    }
                  </td>
                  <td *matFooterCellDef mat-footer-cell>
                    @if (quote.assessed) {
                      <div class="amount-cell">
                        <div class="sign-cell-total">$</div>
                        {{ labourSection.value.totalAssessedAmount | number: '1.2-2' }}
                      </div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="delete">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell></th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    @if (
                      quote.manual &&
                      !quote.submitted &&
                      labourItem(i).controls.length > 1 &&
                      labourItem(i).controls.length !== index + 1
                    ) {
                      <div class="amount-cell delete">
                        <mat-icon (click)="deleteItem(item.id, index, 'labourItem', i)">delete</mat-icon>
                      </div>
                    }
                  </td>
                </ng-container>
                <tr *matHeaderRowDef="labourColumnHeaders" mat-header-row></tr>
                <tr
                  *matRowDef="let item; let even = even; columns: labourColumnHeaders; let j = index"
                  mat-row
                  [ngClass]="{ 'merged-row': item.mergedFromReUpload }"
                  [class.row-manual-quote]="quote.manual"></tr>
                <tr
                  *matFooterRowDef="labourColumnFooters"
                  mat-footer-row
                  [hidden]="quote.manual && !quote.submitted"></tr>
              </table>
            </div>
            @if (
              overviewCheckbox.checked &&
              (labourSection.value.items | filter: 'OVERVIEW' : overviewCheckbox.checked).length === 0
            ) {
              <div class="no-adjusted-line subtitle-2">
                <mat-icon>info_outlined</mat-icon>
                <span class="banner-text"
                  >No adjusted lines. <a (click)="overviewCheckbox.checked = false">Clear your filter</a> to see all
                  lines</span
                >
              </div>
            }
          </div>
        }
        <!-- PARTS SECTION -->
        @if (quote.parts?.length || quote.manual) {
          <div class="part-section" formArrayName="partItems">
            <h4 class="part-section-header">Parts</h4>
            <table
              [dataSource]="partItems.value | filter: 'OVERVIEW' : overviewCheckbox.checked"
              class="table-style"
              mat-table
              [trackBy]="trackByForSubletsAndParts"
              #partTable>
              @if (!isLargeScreen) {
                <ng-container matColumnDef="partDescriptionNumber">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>
                    <div>Description / Part Number</div>
                  </th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    <div class="description-cell">
                      <ng-container
                        [ngTemplateOutletContext]="{ item: item }"
                        [ngTemplateOutlet]="assessedStatusIndicator"></ng-container>
                      @if (!quote.manual || quote.submitted) {
                        <div>
                          <div>{{ item.description }}</div>
                          <div>{{ item.partNumber }}</div>
                        </div>
                      }
                      @if (quote.manual && !quote.submitted) {
                        <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                          <input
                            formControlName="description"
                            id="{{ 'descriptionPartsSmall-' + index }}"
                            type="text"
                            (focusout)="addOrEditLineParts(index)"
                            matInput />
                          @if (partItems.controls[index].get('description').errors?.required) {
                            <mat-error>Description is <strong>required</strong></mat-error>
                          }
                        </mat-form-field>
                      }
                      @if (quote.manual && !quote.submitted) {
                        <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                          <input
                            formControlName="partNumber"
                            id="{{ 'partNumberPartsSmall-' + index }}"
                            (focusout)="addOrEditLineParts(index)"
                            type="text"
                            matInput />
                        </mat-form-field>
                      }
                    </div>
                  </td>
                </ng-container>
              } @else {
                <ng-container matColumnDef="partDescription">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Description</th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    <div class="description-cell">
                      <ng-container
                        [ngTemplateOutletContext]="{ item: item, added: item.addedInV6 }"
                        [ngTemplateOutlet]="assessedStatusIndicator" />

                      @if (!quote.manual || quote.submitted) {
                        <div>{{ item.description }}</div>
                      }
                      @if (quote.manual && !quote.submitted) {
                        <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                          <input
                            formControlName="description"
                            id="{{ 'descriptionPartsLarge-' + index }}"
                            (focusout)="addOrEditLineParts(index)"
                            type="text"
                            matInput />
                          @if (partItems.controls[index].get('description').errors?.required) {
                            <mat-error>Description is <strong>required</strong></mat-error>
                          }
                        </mat-form-field>
                      }
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="partNumber">
                  <th *matHeaderCellDef class="text-14!" mat-header-cell>Part Number</th>
                  <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                    @if (!quote.manual || quote.submitted) {
                      <div>{{ item.partNumber }}</div>
                    }
                    @if (quote.manual && !quote.submitted) {
                      <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                        <input
                          formControlName="partNumber"
                          id="{{ 'partNumberPartsLarge-' + index }}"
                          (focusout)="addOrEditLineParts(index)"
                          type="text"
                          matInput />
                      </mat-form-field>
                    }
                  </td>
                </ng-container>
              }

              <ng-container matColumnDef="partSource">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Part Source</th>
                <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                  @if (!quote.manual || quote.submitted) {
                    <div>{{ item.partSource }}</div>
                  }
                  @if (quote.manual && !quote.submitted) {
                    <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                      <mat-select formControlName="partSource" id="{{ 'partSource-' + index }}">
                        <mat-select-trigger>
                          {{ partItems.value[index].partSource }}
                        </mat-select-trigger>
                        @for (part of partSourceOptions; track part.code) {
                          <mat-option [value]="part.code" (focusout)="addOrEditLineParts(index)">
                            {{ part.code }} - {{ part.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="assessorNote">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessor Note</th>
                <td *matCellDef="let item; let index = index" class="emphasis" mat-cell [formGroupName]="index">
                  @if (item.assessorNote) {
                    <div class="note-container">
                      <mat-icon class="note-icon">add_comment</mat-icon>
                      <div>{{ item.assessorNote }}</div>
                    </div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Qty.</th>
                <td *matCellDef="let item; let index = index" class="quantity" mat-cell [formGroupName]="index">
                  @if (!quote.manual || quote.submitted) {
                    <div>{{ item.quantity }}</div>
                  }
                  @if (quote.manual && !quote.submitted) {
                    <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                      <input
                        formControlName="quantity"
                        id="{{ 'quantity-' + index }}"
                        (focusout)="addOrEditLineParts(index)"
                        onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57);"
                        matInput />
                      @if (partItems.controls[index]?.get('quantity')?.errors?.min) {
                        <mat-error>Must be at least 1</mat-error>
                      }
                    </mat-form-field>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="total">
                <td *matFooterCellDef mat-footer-cell class="text-end" [attr.colspan]="partColumnHeaders.length - 4">
                  <div class="font-normal my-20">Subtotal</div>
                  <div class="font-normal">Markup</div>
                  <div class="my-20">Total</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="estimateAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Est. Amount</th>
                <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                  @if (!quote.manual || quote.submitted) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      <div>{{ item.estimateAmount }}</div>
                    </div>
                  }
                  @if (quote.manual && !quote.submitted) {
                    <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                      <input
                        formControlName="estimateAmount"
                        id="{{ 'estimateAmountParts-' + index }}"
                        (focusout)="addOrEditLineParts(index)"
                        matInput />
                      @if (item.estimateAmount) {
                        <div class="prefix body-1" matPrefix>$</div>
                      }
                      @if (partItems.controls[index].get('estimateAmount').errors?.pattern) {
                        <mat-error>Invalid format</mat-error>
                      }
                      @if (partItems.controls[index].get('estimateAmount').errors?.required) {
                        <mat-error>Amount is <strong>required</strong></mat-error>
                      }
                    </mat-form-field>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  <div class="amount-cell font-normal my-20">
                    <div class="sign-cell-total">$</div>
                    {{ quote.estPartsSubTotal | number: '1.2-2' }}
                  </div>
                  <div class="amount-cell font-normal">
                    <div class="sign-cell-total">$</div>
                    {{ quote.estPartsMarkupTotal | number: '1.2-2' }}
                  </div>
                  <div class="amount-cell my-20">
                    <div class="sign-cell-total">$</div>
                    {{ quote.estPartsTotal | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="estimateMarkup">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Est. Markup</th>
                <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                  @if (!quote.manual || quote.submitted) {
                    <div>{{ item.estimateMarkup | number: '1.2-2' }} %</div>
                  }
                  @if (quote.manual && !quote.submitted) {
                    <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                      <input
                        formControlName="estimateMarkup"
                        id="{{ 'estimateMarkup-' + index }}"
                        (focusout)="addOrEditLineParts(index)"
                        onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57);"
                        matInput />
                      @if (item.estimateMarkup) {
                        <div class="text-charcoal-60 w-10 mr-10 body-1" matSuffix>%</div>
                      }
                      <mat-error>Enter number</mat-error>
                    </mat-form-field>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell></td>
              </ng-container>
              <ng-container matColumnDef="assessedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>
                  <ng-container> Ass. Amount </ng-container>
                </th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.assessedAmount || item.assessedAmount === 0) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      <div
                        [ngClass]="{
                          emphasis: item.assessedStatus !== 'ASSESSED_EQUAL',
                          red: item.assessedStatus === 'ASSESSED_REJECTED'
                        }"
                        class="assess-indicator">
                        {{ item.assessedAmount | number: '1.2-2' }}
                        <ng-container
                          [ngTemplateOutletContext]="{ item: item, small: true, added: item.addedInV6 }"
                          [ngTemplateOutlet]="assessedStatusIndicator"></ng-container>
                      </div>
                    </div>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  @if (quote.assessed) {
                    <div class="amount-cell font-normal my-20">
                      <div class="sign-cell-total">$</div>
                      {{ quote.assessedPartsSubTotal | number: '1.2-2' }}
                    </div>
                  }
                  @if (quote.assessed) {
                    <div class="amount-cell font-normal">
                      <div class="sign-cell-total">$</div>
                      {{ quote.assessedPartsMarkupTotal | number: '1.2-2' }}
                    </div>
                  }
                  @if (quote.assessed) {
                    <div class="amount-cell my-20">
                      <div class="sign-cell-total">$</div>
                      {{ quote.assessedPartsTotal | number: '1.2-2' }}
                    </div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="assessedMarkup">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>
                  <ng-container> Ass. Markup </ng-container>
                </th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.assessedMarkupPercent || item.assessedMarkupPercent === 0) {
                    {{ item.assessedMarkupPercent | number: '1.2-2' }} %
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell></td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th *matHeaderCellDef class="text-14!" mat-header-cell></th>
                <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                  @if (
                    quote.manual &&
                    !quote.submitted &&
                    partItems.controls.length > 1 &&
                    partItems.controls.length !== index + 1
                  ) {
                    <div class="amount-cell delete">
                      <mat-icon (click)="deleteItem(item.id, index, 'partItem', null)">delete</mat-icon>
                    </div>
                  }
                </td>
              </ng-container>
              <tr *matHeaderRowDef="partColumnHeaders" mat-header-row></tr>
              <tr
                *matRowDef="let item; let even = even; columns: partColumnHeaders"
                mat-row
                [class.row-manual-quote]="quote.manual"
                [ngClass]="{ 'merged-row': item.mergedFromReUpload }"
                class="parts"></tr>
              <tr *matFooterRowDef="partColumnFooters" mat-footer-row [hidden]="quote.manual && !quote.submitted"></tr>
            </table>
            @if (
              overviewCheckbox.checked && (quote.parts | filter: 'OVERVIEW' : overviewCheckbox.checked).length === 0
            ) {
              <div class="no-adjusted-line subtitle-2">
                <mat-icon>info_outlined</mat-icon>
                <span class="banner-text"
                  >No adjusted lines. <a (click)="overviewCheckbox.checked = false">Clear your filter</a> to see all
                  lines</span
                >
              </div>
            }
          </div>
        }

        <!-- SUBLETS SECTION -->
        @if (quote.sublets?.length || quote.manual) {
          <div class="sublet-section" formGroupName="subletItems">
            <h4 class="part-section-header">Sublets</h4>
            <table
              [dataSource]="subletItems.value | filter: 'OVERVIEW' : overviewCheckbox.checked"
              class="table-style"
              mat-table
              [trackBy]="trackByForSubletsAndParts"
              #subletTable>
              <ng-container matColumnDef="description">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Description</th>
                <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                  <div class="description-cell">
                    <ng-container
                      [ngTemplateOutletContext]="{ item: item, added: item.addedInV6 }"
                      [ngTemplateOutlet]="assessedStatusIndicator"></ng-container>
                    @if (!quote.manual || quote.submitted) {
                      <div>{{ item.description }}</div>
                    }
                    @if (quote.manual && !quote.submitted) {
                      <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                        <input
                          formControlName="description"
                          id="{{ 'descriptionSublet-' + index }}"
                          (focusout)="addOrEditLineSublets(index)"
                          type="text"
                          matInput
                          #subletDescriptionsRef />
                        @if (subletItems.controls[index].get('description').errors?.required) {
                          <mat-error>Description is <strong>required</strong></mat-error>
                        }
                      </mat-form-field>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="note">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Assessor Note</th>
                <td *matCellDef="let item; let index = index" class="emphasis" mat-cell [formGroupName]="index">
                  @if (item.assessorNote) {
                    <div class="note-container">
                      <mat-icon class="note-icon">add_comment</mat-icon>
                      <div>{{ item.assessorNote }}</div>
                    </div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="total">
                <td *matFooterCellDef mat-footer-cell class="text-end" colspan="2">
                  <div>Total</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="estimateAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Est. Amount</th>
                <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                  @if (!quote.manual || quote.submitted) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      <div>{{ item.estimateAmount }}</div>
                    </div>
                  }
                  @if (quote.manual && !quote.submitted) {
                    <mat-form-field subscriptSizing="dynamic" class="quote-column-field sm no-label">
                      <input
                        formControlName="estimateAmount"
                        id="{{ 'estimateAmountSublet-' + index }}"
                        (focusout)="addOrEditLineSublets(index)"
                        matInput />
                      @if (item.estimateAmount) {
                        <div class="prefix body-1" matPrefix>$</div>
                      }
                      @if (subletItems.controls[index].get('estimateAmount').errors?.pattern) {
                        <mat-error>Invalid format</mat-error>
                      }
                      @if (subletItems.controls[index].get('estimateAmount').errors?.required) {
                        <mat-error>Amount is <strong>required</strong></mat-error>
                      }
                    </mat-form-field>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  <div class="amount-cell">
                    <div class="sign-cell-total">$</div>
                    {{ quote.estSubletTotal | number: '1.2-2' }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="empty">
                <th *matHeaderCellDef class="text-14!" mat-header-cell></th>
                <td *matCellDef="let item" mat-cell></td>
                <td *matFooterCellDef mat-footer-cell></td>
              </ng-container>
              <ng-container matColumnDef="assessedAmount">
                <th *matHeaderCellDef class="text-14!" mat-header-cell>Ass. Amount</th>
                <td *matCellDef="let item" mat-cell>
                  @if (item.assessedAmount || item.assessedAmount === 0) {
                    <div class="amount-cell">
                      <div class="sign-cell">$</div>
                      <div
                        [ngClass]="{
                          emphasis: item.assessedStatus !== 'ASSESSED_EQUAL',
                          red: item.assessedStatus === 'ASSESSED_REJECTED'
                        }"
                        class="assess-indicator">
                        {{ item.assessedAmount | number: '1.2-2' }}
                        <ng-container
                          [ngTemplateOutletContext]="{ item: item, small: true, added: item.addedInV6 }"
                          [ngTemplateOutlet]="assessedStatusIndicator"></ng-container>
                      </div>
                    </div>
                  }
                </td>
                <td *matFooterCellDef mat-footer-cell>
                  @if (quote.assessed) {
                    <div class="amount-cell">
                      <div class="sign-cell-total">$</div>
                      {{ quote.assessedSubletTotal | number: '1.2-2' }}
                    </div>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th *matHeaderCellDef class="text-14!" mat-header-cell></th>
                <td *matCellDef="let item; let index = index" mat-cell [formGroupName]="index">
                  @if (
                    quote.manual &&
                    !quote.submitted &&
                    subletItems.controls.length > 1 &&
                    subletItems.controls.length !== index + 1
                  ) {
                    <div class="amount-cell delete">
                      <mat-icon (click)="deleteItem(item.id, index, 'subletItem', null)">delete</mat-icon>
                    </div>
                  }
                </td>
              </ng-container>
              <tr *matHeaderRowDef="subletsColumnHeaders" mat-header-row></tr>
              <tr
                *matRowDef="let item; let even = even; columns: subletsColumnHeaders"
                mat-row
                [ngClass]="{ 'merged-row': item.mergedFromReUpload }"
                [class.row-manual-quote]="quote.manual"></tr>
              <tr
                *matFooterRowDef="subletsColumnFooters"
                mat-footer-row
                [hidden]="quote.manual && !quote.submitted"></tr>
            </table>
            @if (
              overviewCheckbox.checked && (quote.sublets | filter: 'OVERVIEW' : overviewCheckbox.checked).length === 0
            ) {
              <div class="no-adjusted-line subtitle-2">
                <mat-icon>info_outlined</mat-icon>
                <span class="banner-text"
                  >No adjusted lines. <a (click)="overviewCheckbox.checked = false">Clear your filter</a> to see all
                  lines</span
                >
              </div>
            }
          </div>
        }
      </form>
    </mat-expansion-panel>
  </div>
}

<ng-template #assessedStatusIndicator let-added="added" let-item="item" let-small="small">
  <div [class.added]="item.addedInV6" [class.small]="small" [ngClass]="item.assessedStatus" class="indicator">
    @if (added) {
      <mat-icon>add</mat-icon>
    } @else {
      @switch (item.assessedStatus) {
        @case ('ASSESSED_EQUAL') {
          @if (!small) {
            <mat-icon>check</mat-icon>
          }
        }
        @case ('ASSESSED_REJECTED') {
          <mat-icon>clear</mat-icon>
        }
        @case ('ASSESSED_UNDER') {
          <mat-icon>keyboard_arrow_down</mat-icon>
        }
        @case ('ASSESSED_OVER') {
          <mat-icon>keyboard_arrow_up</mat-icon>
        }
      }
    }
  </div>
</ng-template>

<ng-template #assessedTotals let-assessedAmount="assessedAmount" let-estimatedAmount="estimatedAmount">
  @if (quote.assessed) {
    <div class="assess-indicator no-margin">
      <div
        [ngClass]="{
          ASSESSED_UNDER: assessedAmount !== estimatedAmount,
          ASSESSED_EQUAL: assessedAmount === estimatedAmount
        }"
        class="indicator small margin-left-10">
        @if (assessedAmount < estimatedAmount) {
          <mat-icon>keyboard_arrow_down</mat-icon>
        } @else if (assessedAmount > estimatedAmount) {
          <mat-icon>keyboard_arrow_up</mat-icon>
        } @else if (assessedAmount === estimatedAmount) {
          <mat-icon>check</mat-icon>
        }
      </div>
    </div>
  }

  @if (assessedAmount !== estimatedAmount) {
    <span class="overview-diff body-2"
      >$
      @if (assessedAmount < estimatedAmount) {
        <span> - </span>
      } @else if (assessedAmount > estimatedAmount) {
        <span> + </span>
      }
      {{ Math.abs(assessedAmount - estimatedAmount) | number: '1.2-2' }}
    </span>
  }
</ng-template>
